import React from "react";
import styles from "../../../styles/home/Components/RecentMessages.module.css";
import img1 from "../../../assets/images/c1.jpeg";
import img2 from "../../../assets/images/c2.jpeg";
import img3 from "../../../assets/images/c3.jpeg";
import img4 from "../../../assets/images/c4.jpeg";
import img5 from "../../../assets/images/c5.jpeg";
import img6 from "../../../assets/images/c6.jpeg";
import img7 from "../../../assets/images/c7.jpeg";

const messages = [
  { image: img1 },
  { image: img2 },
  { image: img3 },
  { image: img4 },
  { image: img5 },
  { image: img6 },
  { image: img7 },
];

export default function RecentMessages() {
  // Duplicate messages array for seamless scrolling
  const allCards = [...messages, ...messages];

  return (
    <section className={styles.section}>
      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          {/* Title */}
          <h2 className={styles.title}>
            Discover Our <span className={styles.titleGradient}>Recent Messages</span>
          </h2>
          
          {/* Description */}
          <p className={styles.description}>
            Dive into powerful teachings that transform lives and strengthen faith. Each message from{" "}
            <span className={styles.highlight}>Apostle Sebagabo Christophe and other God's Generals</span> in the body of Christ Jesus brings{" "}
            <span className={styles.highlight}>biblical truth</span> and{" "}
            <span className={styles.highlight}>practical wisdom</span> to help you grow spiritually 
            and walk boldly in your God-given purpose.
          </p>
          
          {/* CTA Button */}
          <a href="/sermons" className={styles.ctaButton}>
            <span>Explore All Sermons</span>
            <svg className={styles.ctaIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>

      {/* Marquee Section */}
      <div className={styles.marqueeContainer}>
        {/* Left Gradient Fade */}
        <div className={styles.gradientLeft} />
        
        {/* Right Gradient Fade */}
        <div className={styles.gradientRight} />
        
        {/* Scrolling Cards */}
        <div className={styles.marquee}>
          {allCards.map((msg, idx) => (
            <div
              key={idx}
              className={styles.card}
            >
              {/* Image */}
              <img
                src={msg.image}
                alt={`Sermon ${(idx % messages.length) + 1}`}
                className={styles.cardImage}
              />
              
              {/* Gradient Overlay */}
              <div className={styles.cardOverlay} />
              
              {/* Watch Live Button */}
              <a 
                href="https://www.youtube.com/@CMINTERNATIONAL"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.watchButton}
                aria-label="Watch live on YouTube"
              >
                <svg className={styles.playIcon} fill="currentColor" viewBox="0 0 20 20">
                  <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                </svg>
                Watch Live
              </a>
              
              {/* Hover Glow Effect */}
              <div className={styles.cardGlow} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}